module.exports = __webpack_public_path__ + "static/media/Bear Paw_Outline_1c.f9da3e21.svg";